import IconSushiSwapLonDai from '~/assets/images/sushiswap-LON-DAI.svg'
import IconSushiSwapLonEth from '~/assets/images/sushiswap-LON-ETH.svg'
import IconSushiSwapLonUsdt from '~/assets/images/sushiswap-LON-USDT.svg'
import IconUniSwapLonDai from '~/assets/images/uniswap-LON-DAI.svg'
import IconUniSwapLonEth from '~/assets/images/uniswap-LON-ETH.svg'
import IconUniSwapLonUsdt from '~/assets/images/uniswap-LON-USDT.svg'

export const formatLPs = (lps) => {
  const logos = {
    DAI: (pool) =>
      pool.toLowerCase() === 'sushiswap'
        ? IconSushiSwapLonDai
        : IconUniSwapLonDai,
    ETH: (pool) =>
      pool.toLowerCase() === 'sushiswap'
        ? IconSushiSwapLonEth
        : IconUniSwapLonEth,
    USDT: (pool) =>
      pool.toLowerCase() === 'sushiswap'
        ? IconSushiSwapLonUsdt
        : IconUniSwapLonUsdt,
  }

  return lps.map((t) => {
    return {
      ...t,
      link: t.type,
      token: t.lpTokenAddress,
      icon: logos[t.type](t.pool),
      closed: t.closed,
      rewardToken: t.rewardToken,
      pool: t.pool,
    }
  })
}

export const getClosedPolls = (lps) => {
  const closedPollData = lps.filter((t) => t.closed)
  const cachedTimeStamp = []
  const keyMap = {}

  for (let lp of closedPollData) {
    if (cachedTimeStamp.indexOf(lp.endTimestamp) < 0) {
      cachedTimeStamp.push(lp.endTimestamp)

      keyMap[lp.endTimestamp] = [lp]
    } else {
      if (keyMap.hasOwnProperty(lp.endTimestamp)) {
        keyMap[lp.endTimestamp] = keyMap[lp.endTimestamp].concat(lp)
      }
    }
  }

  const filterValue = Object.values(keyMap)

  filterValue.sort(sortFunctionByDesc)
  // order by desc
  function sortFunctionByDesc(a, b) {
    return a['endTimestamp'] < b['endTimestamp'] ? 1 : -1
  }

  return filterValue
}
